import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import React, { useState, useEffect, useCallback, forwardRef } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { isPossiblePhoneNumber } from "libphonenumber-js";

const CustomToggle = forwardRef(({ children, onClick }, ref) => (
  <div
    ref={ref}
    className="form-control custom-dropdown-toggle d-flex flex-row align-items-center"
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </div>
));
export const blockInvalidChar = (e) => ["e", "E", "+", "."].includes(e.key) && e.preventDefault();

export default ({ disabled, code, setCode, countries, register }) => {
  // const [flag, setFlag] = useState("http://purecatamphetamine.github.io/country-flag-icons/3x2/US.svg");

  // const setCountryFlag = useCallback(() => {
  //   if (!code) return;
  //   const country = countries.find((c) => c.country_code == code);
  //   setFlag(`http://purecatamphetamine.github.io/country-flag-icons/3x2/${country.alpha2}.svg`);
  // }, [code, countries]);

  // useEffect(() => {
  //   if (countries && countries.length) {
  //     setCountryFlag();
  //   }
  // }, [countries, setCountryFlag]);

  // const handleCountryChange = (value) => {
  //   setCode(value);
  //   // setCountryFlag();
  // };

  const [value, setValue] = useState("");

  const handleInputChange = (val, country) => {
    if (country?.dialCode) {
      val = val.replace(country?.dialCode, "");
    }
    setValue(val);
    if (!val) {
      return false;
    }
    setCode(country?.dialCode);
  };

  return (
    <div className="d-flex flex-column w-100">
      <div className="pb-1">
        <label className="m-0">Phone number (mobile)</label>
      </div>
      <div className="d-flex flex-row w-100 pb-3">
        <input type="hidden" value={code} name="phone_number_attributes[code]" ref={register} />
        <input type="hidden" value={value} id="phone_number" name="phone_number_attributes[number]" ref={register} />
        <PhoneInput disabled={disabled} country={"us"} preferredCountries={["us"]} value={code + value} onChange={handleInputChange} />
        {/* <div className="col-35 country-code-wrapper">
            <Dropdown className="select custom-dropdown d-flex align-items-center">
              <Dropdown.Toggle as={CustomToggle}>
                {code && <img width="20" height="15" src={flag} className="country-flag" alt="COUNTRY-FLAG" />}
                <div style={{ paddingLeft: 8 }}>+{code}</div>
              </Dropdown.Toggle>
              {!!countries.length && (
                <Dropdown.Menu>
                  <>
                    {countries.map((c) =>
                      c.country_code ? (
                        <Dropdown.Item key={c.alpha2Code} disabled={disabled} onClick={handleCountryChange(c.country_code)}>
                          <img src={`http://purecatamphetamine.github.io/country-flag-icons/3x2/${c.alpha2}.svg`} width="20" height="15" alt="icon" />{" "}
                          +{c.country_code}
                        </Dropdown.Item>
                      ) : null
                    )}
                  </>
                </Dropdown.Menu>
              )}
              <FontAwesomeIcon icon={faChevronDown} />
            </Dropdown>
          </div>

          <div className="col-65 phone-number-wrapper">
            <input
              disabled={disabled}
              type="number"
              name="phone_number_attributes[number]"
              className="form-control"
              style={{ height: "100%" }}
              placeholder="mobile"
              maxLength={20}
              id="phone_number"
              onKeyDown={blockInvalidChar}
              onInput={handleInputChange}
              ref={register}
            />
          </div> */}
      </div>
    </div>
  );
};
